import styled from 'styled-components';

import { ACQ, ACQ_MOBILE, COLORS, GRADIENTS } from '../../../../theme/tokens';
import { hoverWash, lightPanelShadow } from '../../../../theme/mixins';
import { Text } from '../../../../components';

export const Root = styled.div<{ $glow: string }>`
  /* Light theme: Home's score-card shadow at a third of its opacity (the user, 2026-10-22). */
  ${lightPanelShadow}
  display: flex;
  gap: 20px;
  align-items: center;
  /* Match the product/operations insights card so the gauge sits identically. */
  padding: 26px 30px;
  border-radius: 22px;
  background-color: ${ACQ.heroBg};
  /* Radial glow whose hue tracks the main gauge's grade (see heroGlowForScore). */
  background-image: ${(p) => p.$glow};
  background-size: 100% 100%;
  background-repeat: no-repeat;

  ${ACQ_MOBILE} {
    flex-direction: column;
    align-items: stretch;
    padding: 10px;
  }
`;

export const Score = styled.div<{ $expand?: boolean }>`
  display: flex;
  align-items: center;
  gap: 20px;
  width: 355px;
  flex-shrink: 0;
  /* No actions panel beside it → grow to the full card width so the heading flows
     on one line instead of wrapping inside the fixed 355px box. */
  ${(p) => (p.$expand ? 'flex: 1; width: auto;' : '')}

  ${ACQ_MOBILE} {
    width: 100%;
    /* Root stacks to a column on mobile; never let the row-grow leak into a
       vertical stretch. */
    flex: initial;
  }
`;

export const Heading = styled(Text)`
  /* Match the Product page's insight title (InsightsPanel Title). */
  font-size: 18px;
  font-weight: 400;
  color: ${COLORS.textBright};
  line-height: 1.35;
`;

export const Actions = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${ACQ.actionInset};
  border-radius: 22px;
  padding: 20px;

  ${ACQ_MOBILE} {
    background: transparent;
    padding: 0;
  }
`;

export const ActionDivider = styled.div`
  width: 100%;
  height: 1px;
  /* Keep the hover wash on either button from touching the separator line. */
  margin: 5px 0;
  background: ${GRADIENTS.dividerStyledH};
`;

export const Action = styled.button`
  ${hoverWash}
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  height: 48px;
  padding: 0 15px;
  border-radius: 100px;
  background: transparent;
  border: 0;
  text-align: left;
  cursor: pointer;
`;

export const ActionLeft = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`;

export const Spark = styled.img`
  width: 16px;
  height: 16px;
  display: block;
  flex-shrink: 0;
`;

export const ActionLabel = styled(Text)`
  font-size: 14px;
  font-weight: 700;
  color: ${ACQ.white};
  white-space: nowrap;
`;

export const Chev = styled.span`
  display: grid;
  place-items: center;
  color: ${ACQ.t50};
  flex-shrink: 0;
`;
